import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-summer-camp',
  templateUrl: './summer-camp.component.html',
  styleUrls: ['./summer-camp.component.scss']
})
export class SummerCampComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
